<template lang="pug">
BannerCarousel(
    v-if="!$storyblok.isEditing && banners"
    :banners="banners"
    size="HOME"
)
div(
    v-else-if="$storyblok.isEditing"
    class="flex justify-center items-center h-64 bg-gray-light"
)
    p Banner Placeholder

</template>

<script>
import BannerCarousel from '@/components/bannerCarousel'
export default {
    name: 'BannerPlaceholderWidget',
    components: {
        BannerCarousel,
    },
    computed: {
        banners() {
            return this.$store.state.content.data.banners
        },
    },
}
</script>
